import React from 'react'

import Popup from '../../../../popup/Popup'

export default class ErrorPopup extends React.Component {
  render() {
    return (
      <Popup
        className="error"
        iconClass="error"
        closable={false}
        title={this.props.title}
        text={this.props.text}
        onClose={this.props.onClose}
        buttons={this.props.buttons}
      />
    )
  }
}
